import React, { Component } from "react";
import { connect } from "react-redux";
import {
    toggleBinanceAction,
    toggleCreateRenkoAction,
    toggleModelAction,
    toggleTradeModeAction
} from "../../redux/actions/currenciesActions";
import {
    toggleBinanceStatus,
    toggleCreateRenko,
    toggleRunModel
} from "../../services/rashTradeServices";
import { binanceModes } from "../../staticData/strategies";
import { errorToastify, successToastify } from "../../utils/Toastify";
import Modal from "../common-components/Modal";
import SelectInput from "../common-components/SelectInput";
import StartStopbtn from "../common-components/StartStopbtn";
import SwitchToggle from "../common-components/Switch";

class Operations extends Component {
    state = {
        selectedBinanceMode: {
            value: false
        },
        showModal: false
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (
            this.props.isWalletEditable !== nextProps.isWalletEditable ||
            nextProps.isDarkMode != this.props.isDarkMode ||
            nextProps.isTradeOn != this.props.isTradeOn ||
            this.props.isBinanceOn != nextProps?.isBinanceOn ||
            this.props.isRenkoCreationOn != nextProps?.isRenkoCreationOn ||
            this.props.isModelOn != nextProps?.isModelOn ||
            this.state.showModal != nextState.showModal ||
            this.state.selectedBinanceMode.value != nextState?.selectedBinanceMode.value ||
            this.props.currentCurrencyId != nextProps.currentCurrencyId ||
            this.props.isChartDataFormatRenko !== nextProps.isChartDataFormatRenko
        ) {
            return true;
        }
        return false;
    }

    render() {
        const operationsSwitches = [
            {
                switchLabel: `${!this.props.isRenkoCreationOn ? "Run" : "Stop"} ${
                    this.props.isChartDataFormatRenko ? "Renko" : "Candle"
                } Creation`,
                toggleSwitch: () => {
                    this.props.toggleCreateRenkoAction(this.props.isChartDataFormatRenko);
                },
                switchBtnStatus: this.props.isRenkoCreationOn
            },
            {
                switchLabel: `${!this.props.isModelOn ? "Run" : "Stop"} Model`,
                toggleSwitch: () => {
                    this.props.toggleModelAction();
                },
                switchBtnStatus: this.props.isModelOn
            },
            {
                switchLabel: `${!this.props.isBinanceOn ? "Run" : "Stop"} Binance`,
                toggleSwitch: () => this.props.toggleBinanceAction(),
                switchBtnStatus: this.props.isBinanceOn
            },
            {
                switchLabel: `Toggle Trade Mode`,
                toggleSwitch: () => this.props.toggleTradeModeAction(),
                switchBtnStatus: this.props.isTradeOn
            }
        ];
        return (
            <div className="">
                {this.state.showModal ? (
                    <Modal modalClassName="charts_modal " toggleValue={true}>
                        <div className="w-11/12  min-h-26 rounded-md bg-white  flex flex-col items-center primaryBorder border-4 lg:w-1/2 lg:min-h-2xl xl:w-1/3 xl:max-w-5xl  xl:min-h-27 ">
                            <div
                                className={` flex-1 w-full flex items-center justify-center ${
                                    this.props.isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                                }`}>
                                <img
                                    className="max-h-10 my-1 lg:min-h-11 xl:min-h-12"
                                    src="/images/alert.png"
                                    alt=""
                                />
                            </div>
                            <div className="flex-10  px-1 mt-3 lg:mt-5 lg:flex lg:flex-col ">
                                <p
                                    className={`w-full text-justify text-sm mt-2  md:text-lg lg:text-2xl  lg:flex-1 lg:flex lg:justify-center lg:items-center xl:text-2xl text-[#000]`}>
                                    Confirm to run Binance programs?
                                </p>
                                <div className="flex flex-col lg:flex-4 lg:mt-10">
                                    <p
                                        className={`flex-1 flex items-center justify-center lg:items-start text-vsm mt-3 md:text-sm lg:text-lg xl:text-2xl lg:max-h-10 lg:flex-1 text-[#000] `}>
                                        Select the mode{" "}
                                    </p>
                                    <SelectInput
                                        selectFunction={(value) => {
                                            this.setState({ selectedBinanceMode: value });
                                        }}
                                        selectHolder={{
                                            styles: {},
                                            className:
                                                "flex-1  flex justify-center min-h-7  py-3 z-50 rounded-lg lg:max-h-10 xl:max-h-28 lg:flex-4  "
                                        }}
                                        selectOptions={{
                                            holderStyle: {},
                                            className: "flex justify-center relative z-50",
                                            selectedValue: {
                                                defaultText:
                                                    binanceModes[
                                                        this.state.selectedBinanceMode.value
                                                    ]["modeDesc"],
                                                style: {},
                                                className: ` min-w-17 min-h-7    flex justify-center items-center cursor-pointer text-vsm md:min-h-9 md:min-w-21 lg:min-h-10  lg:text-lg xl:text-1xl xl:max-w-28 xl:max-h-16  ${
                                                    this.props.isDarkMode
                                                        ? "bg-secondaryDark"
                                                        : "bg-secondaryLight"
                                                }`
                                            },
                                            list: {
                                                holderStyle: {},
                                                className: "absolute top-8 lg:top-10 xl:top-16",
                                                options: Object.values(binanceModes),
                                                singleOption: {
                                                    divStyle: {
                                                        zIndex: 100
                                                    },
                                                    divClassName: `  z-50 min-w-17 ${
                                                        this.props.isDarkMode ? "border-1" : ""
                                                    } min-h-7 mt-2 primaryBoxShadow flex items-center justify-center cursor-pointer md:min-h-9 md:min-w-21 lg:text-3xl lg:min-h-10 xl:min-h-12 xl:text-2xl xl:max-w-28 ${
                                                        this.props.isDarkMode
                                                            ? "bg-secondaryDark"
                                                            : "bg-secondaryLight"
                                                    }`,
                                                    labelStyle: {
                                                        cursor: "pointer"
                                                    },
                                                    labelClassName: "text-vsm lg:text-sm",
                                                    inputStyle: {
                                                        display: "none"
                                                    }
                                                }
                                            }
                                        }}
                                        optionName={"modeDesc"}
                                        isEditable={true}
                                    />
                                </div>
                                <StartStopbtn
                                    parentDivClassName={
                                        "w-full flex  justify-around mt-4 flex-1 flex-row-reverse"
                                    }
                                    // positiveActive={isModelActive}
                                    negativeActive={false}
                                    positiveClassName=" bg-secondaryGreen text-white hover:scale-105  p-1  rounded-sm min-w-8 w-20 max-h-8 lg:min-h-12 lg:min-w-18 lg:text-1xl xl:min-h-10 xl:mb-4"
                                    negativeClassName="bg-secondaryRed text-white hover:scale-105 p-1  rounded-sm min-w-8 w-20 max-h-8 lg:min-h-12 lg:min-w-18 lg:text-1xl xl:min-h-10 xl:mb-4"
                                    positiveFunc={() => {
                                        this.setState(
                                            {
                                                showModal: false
                                            },
                                            () => {
                                                this.props.toggleBinanceAction(
                                                    this.state.selectedBinanceMode.value
                                                );
                                            }
                                        );
                                    }}
                                    negativeFunc={() => this.setState({ showModal: false })}
                                    positiveText="Run"
                                    negativeText="Cancel"
                                />
                            </div>
                        </div>
                    </Modal>
                ) : null}
                <fieldset className="flex w-full flex-col items-center primaryBorder rounded-sm px-2">
                    <legend className="block p-1 text-sm">Operations</legend>

                    {operationsSwitches.map((operation, index) => {
                        const { switchBtnStatus, toggleSwitch, switchLabel } = operation;
                        return (
                            <div
                                className={`flex  m-3  p-2 rounded-lg w-full ${
                                    this.props.isDarkMode
                                        ? "bg-secondaryDark "
                                        : "bg-secondaryLight "
                                }`}>
                                <div className="flex-2 text-sm">{switchLabel}</div>
                                <SwitchToggle
                                    key={index}
                                    setSwitch={() => {
                                        if (this.props.isWalletEditable) {
                                            return errorToastify("Update the Wallet!");
                                        }
                                        toggleSwitch();
                                    }}
                                    styles={{
                                        parentDiv: {},
                                        label: {},
                                        input: {},
                                        sliderDiv: {},
                                        sliderSwitch: {
                                            left: !switchBtnStatus ? "3%" : "68%"
                                        }
                                    }}
                                    classNames={{
                                        parentDiv: `switch__holder `,
                                        label: "switch",
                                        input: "",
                                        sliderDiv: `slider round ${
                                            !switchBtnStatus
                                                ? " bg-secondaryRed"
                                                : " bg-secondaryGreen"
                                        } ${this.props.isDarkMode ? "border-1 " : "border-0 "}`,
                                        sliderSwitch: "slider-circle"
                                    }}
                                    // switchBolean={false}
                                />
                            </div>
                        );
                    })}
                </fieldset>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        persistedReducer: { currenciesList, currentCurrencyId, isDarkMode }
    } = state;
    const {
        operations: { isRenkoCreationOn, isModelOn, isBinanceOn, isTradeOn },
        isChartDataFormatRenko
    } = currenciesList[currentCurrencyId];
    return {
        isRenkoCreationOn,
        isModelOn,
        isBinanceOn,
        isTradeOn,
        currentCurrencyId,
        isDarkMode,
        isChartDataFormatRenko
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleCreateRenkoAction: (isChartDataFormatRenko) =>
            dispatch(toggleCreateRenkoAction(isChartDataFormatRenko)),
        toggleModelAction: () => dispatch(toggleModelAction()),
        toggleBinanceAction: () => dispatch(toggleBinanceAction()),
        toggleTradeModeAction: () => dispatch(toggleTradeModeAction())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Operations);
